const $ = jQuery = require('jquery')

$("body").on('click', '.js-spread-link', function()
{
    $link = $(this).find("a");
    href = $link.attr("href");
    target = $link.attr("target");

    if(target == '_blank')
        window.open(href, '_blank')
    else
        window.location = href

    return false;
});
